export default {
  state (state) {
    return state
  }
}



// WEBPACK FOOTER //
// ./src/store/cantAccess/getters.js